export default __webpack_public_path__ + "static/media/information--pedestrians-crossing--g1.c953e4e9.png";